"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.types = exports.regexMessage = exports.price = exports.postCode = exports.phone = exports.noUrls = exports.noSpam = exports.noMarkup = exports.name = exports.input = exports.fullName = exports.freeText = exports.emailOrNumber = exports.email = exports.date = exports.contactDetails = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/keys"));
var Joi = _interopRequireWildcard(require("joi"));
var _context, _context2;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var regexMessage = base => ({
  language: {
    string: {
      regex: {
        base
      }
    }
  }
});
exports.regexMessage = regexMessage;
var noUrls = exports.noUrls = /^((?!(https?:\/\/|\.[a-z]+\/|\.(com|org|net|com\.au|co\.nz|ly)\b|\b(goo\.gl|is\.gd|t\.co)\b))[\s\S])*$/gi;
var noMarkup = exports.noMarkup = /^((?!<[^>]*>)[\s\S])*$/g;
var noSpam = exports.noSpam = Joi.string().regex(noUrls).regex(noMarkup).options(regexMessage('may not contain links or markup'));
var input = exports.input = Joi.string().replace(/(^\s+|\s+$)/g, '');
var freeText = exports.freeText = (0, _concat.default)(input).call(input, noSpam);
var email = exports.email = input.email({
  minDomainAtoms: 2
});
var name = exports.name = (0, _concat.default)(input).call(input, noSpam).min(2).max(100);
var fullName = exports.fullName = (0, _concat.default)(input).call(input, noSpam).min(5).max(100).regex(/[^\s]\s+[^\s]/).options(regexMessage('must contain your full name'));
var phone = exports.phone = input.regex(/^(\+\d+)?\s*(\(\d+\)\s+)?[0-9 ]+$/) // Looks like a phone number
.regex(/([0-9].*){8,15}/) // Contains between 8 and 15 digits
.options(regexMessage('must be a valid phone number'));
var postCode = exports.postCode = input.regex(/^\d{4}$/).options(regexMessage('must be four digits, e.g. 1234.'));
var date = exports.date = Joi.string().regex(/^\d{1,2}\/\d{1,2}\/(\d{2}|\d{4})$/).options(regexMessage('must be a valid date in DD/MM/YYYY format.'));
var price = exports.price = Joi.number().integer();
var types = exports.types = {
  noUrls,
  noMarkup,
  noSpam,
  input,
  freeText,
  email,
  name,
  phone,
  postCode,
  date,
  price,
  fullName
};
var emailOrNumber = exports.emailOrNumber = (0, _keys.default)(_context = Joi.object()).call(_context, {}).options({
  abortEarly: false,
  language: {
    object: {
      missing: '!!Please provide either an email or phone number'
    }
  }
}).or('number', 'email');
var contactDetails = exports.contactDetails = (0, _concat.default)(emailOrNumber).call(emailOrNumber, (0, _keys.default)(_context2 = Joi.object()).call(_context2, {
  name: name.label('Your name').required(),
  email: email.label('Your email').allow('').empty(''),
  number: phone.label('Your number').allow('').empty('')
}));